/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementGetUserByTokenResponse } from "./UserManagementGetUserByTokenResponse";

export type UserManagementGetUserByTokenResponseApiRespoonse = {
  data?: UserManagementGetUserByTokenResponse;
  status?: UserManagementGetUserByTokenResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementGetUserByTokenResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
